import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {

  successMessage: string;

  constructor(private activetedRoute: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {

      this.successMessage = '<div class="row text-center"><strong>Congratulations!</strong> You have successfully subscribed for <b>Premium Plan</b>.</div>'+
                '<hr>Your Executive Eye credentials and subscription details has been sent to your registered email. '+
                '<br><br>Please <a (click)="goToXeyePortal();">click here</a> to login with <a (click)="goToXeyePortal();">Executive Eye portal</a> ';
  }

  goToXeyePortal(): void {
    window.open("https://portal.executive-eye.com", "_blank");

  }

}



// WEBPACK FOOTER //
// ./src/app/payment-success/payment-success.component.ts